import AcademicDept from "./AcademicDep";

export default AcademicDept;